// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__fyTxx","loader":"Loading_loader__SIjT9","Loading_Show":"Loading_Loading_Show__quoRu"};